import { useState } from "react";
import styled from "styled-components";
import NameRelationHeader from "./NameRelationHeader";
import ConfirmRequestGridLayout from "./ConfirmRequestGridLayout";

const ConfirmRequestAccordion = ({ data }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const handleClick = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };
  return (
    <div>
      <NameRelationHeader
        firstName={data.firstName}
        lastName={data.lastName}
        name={data.memberName}
        relation={data.relationshipStatus}
        // index={1} //need to revisit
        handleClick={handleClick}
        isAccordionOpen={isAccordionOpen}
      />
      <DesktopWrapper>
        <ConfirmRequestGridLayout data={data} />
      </DesktopWrapper>
      {isAccordionOpen && (
        <MobileWrapper>
          <ConfirmRequestGridLayout data={data} />
        </MobileWrapper>
      )}
    </div>
  );
};

const DesktopWrapper = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
  @media (min-width: 769px) {
    display: block;
  }
`;

const MobileWrapper = styled.div`
  @media (max-width: 768px) {
    display: block;
  }
  @media (min-width: 769px) {
    display: none;
  }
`;

export default ConfirmRequestAccordion;
